import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Input,
} from "@devhop/ui";
import { AlertTriangle } from "lucide-react";
import { useState } from "react";

type VoidOrderDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  orderNo: number;
  orderStatus: string;
  onConfirm: (reason?: string) => void | Promise<void>;
  requireReason?: boolean;
  isSubmitting?: boolean;
};

export function VoidOrderDialog({
  open,
  onOpenChange,
  orderNo,
  orderStatus,
  onConfirm,
  requireReason = false,
  isSubmitting = false,
}: VoidOrderDialogProps) {
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    const trimmedReason = reason.trim();
    if (requireReason && !trimmedReason) return;
    void onConfirm(trimmedReason || undefined);
    setReason("");
    onOpenChange(false);
  };

  const handleCancel = () => {
    setReason("");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleCancel}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
            ຍົກເລີກ Order
          </DialogTitle>
          <DialogDescription>
            ທ່ານກຳລັງຈະຍົກເລີກ Order #{orderNo} ({orderStatus})
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="rounded-lg border border-destructive/50 bg-destructive/10 p-3">
            <p className="font-medium text-destructive text-sm">
              ຄຳເຕືອນ: ການຍົກເລີກ Order ບໍ່ສາມາດຍົກເລີກໄດ້
            </p>
            <p className="mt-2 text-destructive text-sm">
              Order ນີ້ຈະຖືກປ່ຽນສະຖານະເປັນ VOID ແລະບໍ່ສາມາດກັບຄືນໄດ້
            </p>
          </div>

          <div>
            <label
              htmlFor="void-order-reason"
              className="mb-2 block text-muted-foreground text-sm"
            >
              ເຫດຜົນ {requireReason ? "(ຈຳເປັນ)" : "(ທາງເລືອກ)"}:
            </label>
            <Input
              id="void-order-reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="ປ້ອນເຫດຜົນການຍົກເລີກ..."
              className="w-full"
            />
            {requireReason && !reason.trim() && (
              <p className="mt-1 text-destructive text-xs">
                ກະລຸນາປ້ອນເຫດຜົນກ່ອນຢືນຢັນ
              </p>
            )}
          </div>
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={handleCancel}
            disabled={isSubmitting}
          >
            ຍົກເລີກ
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={isSubmitting || (requireReason && !reason.trim())}
          >
            ຢືນຢັນຍົກເລີກ
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
